import { TagsManagement } from "@/features/tags/tags-management";

const TagsScreen = () => {
  return (
    <div className="p-4">
      <TagsManagement />
    </div>
  );
};

export default TagsScreen;
